// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FormTextArea from "../../../../../../library/components/generic-components/components/FormTextArea.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as CheckBoxGroup$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/check-box-group/CheckBoxGroup.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormCheckBoxInput.bs.js";

function isCommentRequired(available_issues, selected_issues) {
  return List.exists((function (issue) {
                return List.exists((function (temp) {
                              if (issue === temp.issue_name) {
                                return temp.issue_comment_required;
                              } else {
                                return false;
                              }
                            }), available_issues.issues);
              }), selected_issues);
}

var validators_comment = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var comment = param.comment;
      if (isCommentRequired(metadata.available_issues, param.selectedIssues) && !(comment !== undefined && comment.trim().length !== 0)) {
        return {
                TAG: /* Error */1,
                _0: "Comments are mandatory with these issues"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: comment
              };
      }
    })
};

var validators_selectedIssues = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var selectedIssues = param.selectedIssues;
      var match = List.length(selectedIssues);
      if (match !== 0) {
        return {
                TAG: /* Ok */0,
                _0: selectedIssues
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select issue"
              };
      }
    })
};

var validators = {
  comment: validators_comment,
  selectedIssues: validators_selectedIssues
};

function initialFieldsStatuses(_input) {
  return {
          comment: /* Pristine */0,
          selectedIssues: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            comment: /* Pristine */0,
            selectedIssues: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.comment;
  var match_0 = match ? match._0 : Curry._2(validators.comment.validate, input, metadata);
  var match$1 = fieldsStatuses.selectedIssues;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.selectedIssues.validate, input, metadata);
  var commentResult = match_0;
  var commentResult$1;
  if (commentResult.TAG === /* Ok */0) {
    var selectedIssuesResult = match_0$1;
    if (selectedIssuesResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                selectedIssues: selectedIssuesResult._0,
                comment: commentResult._0
              },
              fieldsStatuses: {
                comment: /* Dirty */{
                  _0: commentResult,
                  _1: /* Shown */0
                },
                selectedIssues: /* Dirty */{
                  _0: selectedIssuesResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    commentResult$1 = commentResult;
  } else {
    commentResult$1 = commentResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            comment: /* Dirty */{
              _0: commentResult$1,
              _1: /* Shown */0
            },
            selectedIssues: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurCommentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.comment, validators_comment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: status,
                                  selectedIssues: init.selectedIssues
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSelectedIssuesField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.selectedIssues, validators_selectedIssues, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: init.comment,
                                  selectedIssues: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateCommentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$2 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput, metadata, nextFieldsStatuses.contents.selectedIssues, validators_selectedIssues, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  comment: init.comment,
                                  selectedIssues: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    nextFieldsStatuses.contents = result$2;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, nextFieldsStatuses.contents.comment, state.submissionStatus, validators_comment, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            comment: status,
                                            selectedIssues: init.selectedIssues
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSelectedIssuesField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$3 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.comment, validators_comment, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  comment: status,
                                  selectedIssues: init.selectedIssues
                                };
                        }));
                  if (result$3 !== undefined) {
                    nextFieldsStatuses$1.contents = result$3;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.selectedIssues, state.submissionStatus, validators_selectedIssues, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            comment: init.comment,
                                            selectedIssues: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                comment: /* Pristine */0,
                                selectedIssues: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                comment: /* Pristine */0,
                                selectedIssues: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCommentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSelectedIssues: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSelectedIssuesField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurComment: (function (param) {
              return Curry._1(dispatch, /* BlurCommentField */0);
            }),
          blurSelectedIssues: (function (param) {
              return Curry._1(dispatch, /* BlurSelectedIssuesField */1);
            }),
          commentResult: Formality.exposeFieldResult(state.fieldsStatuses.comment),
          selectedIssuesResult: Formality.exposeFieldResult(state.fieldsStatuses.selectedIssues),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.comment || match.selectedIssues) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialInput(selected_issue) {
  return {
          selectedIssues: selected_issue.selected_issue,
          comment: selected_issue.issue_comment
        };
}

function saveUserData(user_data, dispatch) {
  var value = user_data.issue_comment;
  var userData_selected_issue = user_data.selected_issue;
  var userData_issue_comment = value !== undefined ? value.trim() : undefined;
  var userData = {
    selected_issue: userData_selected_issue,
    issue_comment: userData_issue_comment
  };
  return Curry._1(dispatch, {
              TAG: /* UpdateIssueFormData */6,
              issue_form_data: userData
            });
}

function IssueForm(Props) {
  var issue_form_data = Props.issue_form_data;
  var issues = Props.issues;
  var dispatch = Props.dispatch;
  var form = useForm(getInitialInput(issue_form_data), {
        available_issues: issues
      }, (function (output, _form) {
          var formData_selected_issue = output.selectedIssues;
          var formData_issue_comment = output.comment;
          var formData = {
            selected_issue: formData_selected_issue,
            issue_comment: formData_issue_comment
          };
          saveUserData(formData, dispatch);
          return Curry._1(dispatch, {
                      TAG: /* UpdateView */4,
                      current_view: /* ActionForm */2
                    });
        }));
  return React.createElement("div", {
              className: "c-raise-ticket-form-issue-container"
            }, React.createElement("div", {
                  className: "raise-ticket-form-issue"
                }, React.createElement("div", {
                      className: "raise-ticket-form-issue-section"
                    }, React.createElement("label", {
                          className: "raise-ticket-row-title"
                        }, "Issues"), React.createElement(FormCheckBoxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateSelectedIssues, (function (input, value) {
                                                return {
                                                        selectedIssues: value,
                                                        comment: input.comment
                                                      };
                                              }), CheckBoxGroup$Catalyst.isChecked(form.input.selectedIssues, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                                      return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                                    })(form.input.selectedIssues) : ({
                                                  hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                                  tl: form.input.selectedIssues
                                                }));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.selectedIssuesResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          checkbox_props: {
                            selected: form.input.selectedIssues,
                            options: List.map((function (issue) {
                                    return {
                                            id: issue.issue_name,
                                            label: issue.issue_name,
                                            value: issue.issue_name
                                          };
                                  }), issues.issues),
                            row_layout: true
                          }
                        }), isCommentRequired(issues, form.input.selectedIssues) ? React.createElement("div", undefined, React.createElement("label", {
                                className: "raise-ticket-row-title"
                              }, "Comment"), React.createElement(FormTextArea.make, {
                                input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                        return Curry._2(form.updateComment, (function (input, value) {
                                                      return {
                                                              selectedIssues: input.selectedIssues,
                                                              comment: value
                                                            };
                                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                      }), undefined, undefined, "Please enter comment for the selected issues", undefined, undefined, undefined, form.commentResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: Belt_Option.getWithDefault(form.input.comment, "")
                                }
                              })) : null), React.createElement("div", {
                      className: "raise-ticket-form-issue-btn-wrapper"
                    }, React.createElement(Button$Catalyst.make, {
                          text: "Previous",
                          cb: (function (param) {
                              var formData_selected_issue = form.input.selectedIssues;
                              var formData_issue_comment = form.input.comment;
                              var formData = {
                                selected_issue: formData_selected_issue,
                                issue_comment: formData_issue_comment
                              };
                              saveUserData(formData, dispatch);
                              return Curry._1(dispatch, {
                                          TAG: /* UpdateView */4,
                                          current_view: /* BasicInfoForm */0
                                        });
                            }),
                          className: "raise-ticket-btn raise-ticket-form-back"
                        }), React.createElement(Button$Catalyst.make, {
                          text: "Next",
                          cb: (function (_event) {
                              return Curry._1(form.submit, undefined);
                            }),
                          className: "raise-ticket-btn raise-ticket-form-next"
                        }))));
}

var make = IssueForm;

export {
  isCommentRequired ,
  Form ,
  getInitialInput ,
  saveUserData ,
  make ,
  
}
/* react Not a pure module */
